/*eslint-disable */
import React, { Component } from "react";
import ShipmentHeader from "../../components/vendor-login/ordersComponent/shipmentHeader";
import { Image } from "semantic-ui-react";
import ShipmentGridView from "../../components/vendor-login/ordersComponent/shipmentGridView";
import { readActiveOrdersDispatcher } from "../../redux/actions/shipmentAction";
import { updatePagination, readPagination } from "../../redux/actions/paginationAction";
import { connect } from "react-redux";
import ReadAxios from "../../components/axiosComponent/read";
import AsyncAgGridTable from "../../components/common/asyncAgGridTable";
import { translate } from "react-i18next";
import moment from "moment";
import { isEmpty } from "lodash";
import Orders from "../../components/vendor-login/ordersComponent/orders";

Object.defineProperty(Array.prototype, "chunks", {
  value: function (chunksSize) {
    var R = [];
    for (var i = 0; i < this.length; i += chunksSize)
      R.push(this.slice(i, i + chunksSize));
    return R;
  },
});
class Active_Orders extends Component {

  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      grid: localStorage.getItem('customerNumber') == 1122 ? true : false,
      loadingData: true,
      prevProps: [],
      // ag-grid async call
      locales: props.locales.local,
      rowData: [],
      paginationCallbackData: [],
      chunkedRowData: [],
      currentPageData: [],
      currentPageNumber: -1,
      agGridPageSize: 10,
      componentRenderKey: 0,
      pageNoOn: this.props.paginationIndex.active_order_card_page || 1,
      pageNoOnGrid: this.props.paginationIndex.active_order_grid_page || 1
    };
  }

  async componentDidMount() {
    if (this.props?.paginationIndex?.active_order_card_page)
      this.setState({ pageNoOn: this.props.paginationIndex.active_order_card_page })
    if (this.props?.paginationIndex?.active_order_grid_page)
      this.setState({ pageNoOnGrid: this.props.paginationIndex.active_order_grid_page })
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.locales == nextProps.locales.local) {
      this.setState({ locales: nextProps.locales.local }, () =>
        this.agGridAsyncCalls(nextProps)
      );
    }
  }

  componentWillUnmount() {
    if (!window.location.href.includes('active-order-details')) {
      this.props.updatePagination(1, 'GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE')
      this.props.updatePagination(1, 'GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE')
    }
  }


  updatePaginationPage = (pageNo) => {
    this.props.updatePagination(pageNo, 'GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE')
    if (this.props?.paginationIndex?.active_order_card_page)
      this.setState({ pageNoOn: this.props.paginationIndex.active_order_card_page })
  }

  updateGridPaginationPage = (pageNo) => {
    this.props.updatePagination(pageNo, 'GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE')
    if (this.props?.paginationIndex?.active_order_grid_page)
      this.setState({ pageNoOn: this.props.paginationIndex.active_order_grid_page })
  }

  agGridAsyncCalls(nextProps) {
    if (
      nextProps.shipment &&
      JSON.stringify(this.state.rowData) !==
      JSON.stringify(nextProps.shipment.read)
    ) {
      const { componentRenderKey } = this.state;
      this.setState(
        {
          loadingData: false,
          prevProps: nextProps.shipment.read.chunk(5),
          rowData: nextProps.shipment.read,
          componentRenderKey: componentRenderKey + 1,
        },
        () => console.log("set state 115")
      );
    } else {
      this.setState(
        {
          loadingData: false,
          rowData: [],
          prevProps: [],
        },
        () => console.log("set loading false")
      );
    }
  }

  OnpaginationChangeCallback = (event) => {
    let apiDataJSON = [];
    const agGridPageSize = event.api.paginationProxy.pageSize;
    const agGridCurrentPage = event.api.paginationProxy.currentPage;
    const agGridPageTotalData = this.state.rowData;
    const agGridPageinationData = agGridPageTotalData.chunk(agGridPageSize);
    const agGridCurrentPageData = agGridPageinationData[agGridCurrentPage];
    // prepare data to make api call and merge it with row Data
    apiDataJSON = agGridCurrentPageData.map((item) => {
      return {
        route_id: item.route_id,
        vehicle_id: item.proposed_vehicle_type,
      };
    });
    let agGridCurrentPageFetch = [];
    apiDataJSON.map(async (item, index) => {
      let routeManager =
        (await ReadAxios({ url: `routeManager/${item.route_id}` })) || [];
      let vehicleTypeManager = []
      // (await ReadAxios({ url: `vehicleTypeMaster/${item.vehicle_id}` })) || [];
      routeManager = isEmpty(routeManager) ? [] : routeManager.data.resultSet;
      vehicleTypeManager = isEmpty(vehicleTypeManager)
        ? []
        : vehicleTypeManager.data.resultSet;
      agGridCurrentPageFetch.push({
        source: routeManager[0].checkPointName,
        destination: routeManager[routeManager.length - 1].checkPointName,
        vehicle_type: vehicleTypeManager[0]
          ? vehicleTypeManager[0].vehicleType
          : "",
      });

      if (
        agGridCurrentPageFetch.length == agGridCurrentPageData.length &&
        JSON.stringify(this.state.paginationCallbackData) !=
        JSON.stringify(agGridCurrentPageFetch)
      ) {
        const { componentRenderKey } = this.state;
        this.setState(
          {
            paginationCallbackData: agGridCurrentPageFetch,
            chunkedRowData: agGridPageinationData,
            currentPageData: agGridCurrentPageData,
            currentPageNumber: agGridCurrentPage,
            agGridPageSize: agGridPageSize,
            componentRenderKey: componentRenderKey + 1,
          },
          () => {
            console.log("set state 161");
            this.mergeTheCallbackDataWithRowData();
          }
        );
      }
    });
  };

  mergeTheCallbackDataWithRowData = () => {
    let currentPageNumber = this.state.currentPageNumber;
    let pageSize = this.state.agGridPageSize;
    let rowData = this.state.rowData;
    let currnetFetchData = this.state.paginationCallbackData;
    let currentPageData = this.state.currentPageData;
    let tempRowData = currentPageData.map((item, index) => {
      return Object.assign({}, item, currnetFetchData[index]);
    });
    let startIndex = currentPageNumber * pageSize;
    rowData.splice(startIndex, pageSize, ...tempRowData);
    const { componentRenderKey } = this.state;
    this.setState(
      {
        rowData: rowData,
        componentRenderKey: componentRenderKey + 1,
      },
      () => console.log("set state 147")
    );
  };

  handleGridView = () => {
    const { componentRenderKey } = this.state;
    this.setState(
      {
        loadingData: false,
        grid: !this.state.grid,
        componentRenderKey: componentRenderKey + 1,
      },
      () => console.log("set state 185")
    );
  };

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-shipment", {
      ...rowData,
      title: "Edit Shipment",
    });
  };

  onRowDelete = () => {
    this.props.history.push("/shipment");
    this.props.history.go();
  };

  redirectToShipmentDetail = (item) => {
    let shipment = item[0];
    this.props.history.push({
      pathname: "/shipment-details",
      state: { item: { ...shipment } },
      search: `?shipmentId=${shipment.vendor_shipment_id}`,
    });
  };

  render() {
    const { t } = this.props;
    const { grid, rowData, componentRenderKey } = this.state;
    const columnDefs = [
      {
        headerName: t("table_view.reference_no") || "Refrence No",
        field: "order_reference_no",
        sortable: true,
        filter: true,
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // checkboxSelection: true,
        tooltipField: "order_reference_no",
        enableRowGroup: true,
        enablePivot: true,
        width: 200,
      },
      {
        headerName: t("table_view.status") || "Status",
        field: "allotment_text", // vehicle_type
        sortable: true,
        cellRenderer: "allotment",
        filter: true,
      },
      {
        headerName: t("table_view.source") || "Source",
        field: "source", // source
        cellRenderer: "sourcerender",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.destination") || "Destination",
        field: "destination", // destination
        cellRenderer: "destinationrender",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.bl_no") || "Bl Number",
        field: "bl_numbers", // destination
        // cellRenderer: "blrender",
        tooltipField: "bl_numbers",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.container_number") || "Container Number",
        field: "container_no",
        tooltipField: "container_no",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.vehicle_type") || "Vehicle Type",
        field: "vehicle_type", // vehicle_type
        sortable: true,
        cellRenderer: "vehicletyperenderer",
        filter: true,
      },
      {
        headerName: t("table_view.gross_weight") || "Gross Weight",
        field: "gross_weight",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.movement_type") || "Moment Type",
        field: "movement_type",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.required_on") || "Required On",
        field: "required_on",
        sortable: true,
        filter: true,
        valueFormatter: function (params) {
          return moment(params.value).format("DD-MM-yyyy");
        },
      }
    ];

    return (
      <React.Fragment>
        {/* <ShipmentHeader
          LinkName="/add-shipment"
          title={t("orders.active_title") || "Active Orders"}
          // hidden={true}
          toggleView={this.handleGridView}
          // handleSearch={this.handleChange}
          toggle={!this.state.grid}
        /> */}

        {grid ? (

          <Orders {...this.props} columnDefs={columnDefs} title={t("orders.active_title") || "Active Orders"} toggleView={this.handleGridView} order_status="active" toggle={!this.state.grid} allotedOrdersStatusShow={true}
            updateGridPaginationPage={this.updateGridPaginationPage}
            pageNoOn={this.state.pageNoOnGrid}
            pageNoLast={this.props?.paginationIndex?.active_order_grid_page}
          />
        ) : (
          <ShipmentGridView
            updatePaginationPage={this.updatePaginationPage}
            pageNoOn={this.state.pageNoOn}
            pageNoLast={this.props?.paginationIndex?.active_order_card_page}
            toggleView={this.handleGridView}
            toggle={!this.state.grid}
            shipmentData={this.state.prevProps}
            isLoading={this.state.loadingData}
            allotedOrdersStatusShow={true}
          />
        )}

        {rowData?.length > 0 ? (
          <div
            className="life-cycle w3-white"
            style={{ position: "relative", marginTop: "2em" }}
          >
            {/* <Image
              className="ml-5 pl-5 pt-3 pb-3"
              src="assets/img/ta_life.png"
            /> */}
          </div>
        ) : ""}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ shipment, locales, auth, paginationIndex }) => {
  return {
    shipment,
    locales,
    auth,
    paginationIndex
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updatePagination: (...data) => dispatch(updatePagination(data)),
    readPagination: () => dispatch(readPagination()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("orders")(Active_Orders));
